import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ConnectionHandler from "./connection/ConnectionHandler";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { store } from "./store";

import "./assets/fonts/index.css";
import "./styles/index.css";

const root = createRoot(document.getElementById("root"));

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<ConnectionHandler />
			<App />
		</BrowserRouter>
	</Provider>
);

serviceWorkerRegistration.register();
